import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IStudy } from "../../../Pages/StudyNote.tsx/IStudyNote";

export const ListSubjectNoteSlice = createSlice({
  name: "ListSubjectNoteSlice",
  initialState: {} as IReduxState<IStudy[]>,
  reducers: {
    listSubjectNote: (state) => {
      state.isLoading = true;
    },
    successlistSubjectNote: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSubjectNote: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistSubjectNote,
  listSubjectNote,
  successlistSubjectNote,
} = ListSubjectNoteSlice.actions;

export default ListSubjectNoteSlice.reducer;
